import { useQuery } from '@tanstack/react-query'
import client from '../api/client.js'

export function useFinancials({ scope = 'all' } = {}) {
  return useQuery({
    queryKey: ['actions-financial', scope],
    queryFn: async () => {
      const { data } = await client.get('/actions/financial-impact', { params: { scope } })
      return data
    },
    staleTime: 5 * 60 * 1000,
  })
}
